import { Accordion, AccordionItem, Box, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { WORKER_TYPE_FAQ } from '../constants';

const renderAnswer = (answer: string) =>
  answer.split('\n\n').map((paragraph, i) => (
    <Typography
      key={i}
      size="body_large"
      color={colors.neutral[600]}
      style={{
        marginTop: i === 0 ? 0 : 12,
        lineHeight: 1.5,
        whiteSpace: 'pre-line',
        marginBottom: 0,
      }}
    >
      {paragraph}
    </Typography>
  ));

export const FaqSection = () => (
  <Box pt={8}>
    <Typography
      as="h2"
      bold
      color={colors.neutral[600]}
      style={{ fontSize: 28, margin: 0, marginBottom: 24 }}
    >
      Frequently Asked Questions
    </Typography>
    <Box
      style={{
        backgroundColor: colors.shades[0],
        border: `1.5px solid ${colors.neutral[100]}`,
        borderRadius: 8,
        overflow: 'hidden',
      }}
    >
      <Accordion type="single">
        {WORKER_TYPE_FAQ.map(({ value, question, answer }) => (
          <AccordionItem key={value} value={value} title={question} bold>
            {typeof answer === 'string' ? renderAnswer(answer) : answer}
          </AccordionItem>
        ))}
      </Accordion>
    </Box>
  </Box>
);
